import Plyr from 'plyr';
import bus from '../util/eventBus';

document.addEventListener('DOMContentLoaded', () => {
  const videoPlayer = document.querySelectorAll('.c-video__el');

  if (videoPlayer) {
    let notReady = [];
    Array.from(videoPlayer).forEach(p => {
      const player = new Plyr(p, {
        controls: p.parentNode.querySelector('.c-video__controls'),
        loadSprite: false,
      });

      notReady.push(p);

      player.on('ready', () => {
        notReady = notReady.filter(rp => rp !== p);

        if (notReady.length === 0) {
          bus.emit('ewg-social-grid-recalc');
        }
      });
    });
  }
});



// WEBPACK FOOTER //
// ./src/scripts/modules/videoPlayer.js